import { render, staticRenderFns } from "./_Procedure.vue?vue&type=template&id=96ad5b22&scoped=true"
import script from "./_Procedure.vue?vue&type=script&lang=js"
export * from "./_Procedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ad5b22",
  null
  
)

export default component.exports